import Vue from "vue";
import Component from "vue-class-component";
import * as LoadingGif from "@/assets/gifs/loading.gif";

@Component({
  name: "LoadingScreen",
})
export default class LoadingScreen extends Vue {
  cx_loading_gif = LoadingGif;
  /**
   * -----------------------------------------
   * EVENTS
   * -----------------------------------------
   */
}
